import clsx from 'clsx'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import {
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableBody,
  TableRow,
  TableRowItem,
  TableShimmer,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import PlanningApprovalBadge from 'app/KinerjaTimPenilaiPSPage/components/PlanningApprovalBadge'
import StateEmpty from 'app/KinerjaShared/components/StateEmpty'
import { PENGELOLAAN_KINERJA_BASE_PATH } from 'app/KinerjaShared/constants/path'

import type { PerencanaanPS } from 'types/kinerja-tim-penilai-ps'
import type { StatusPerencanaan } from 'types/kinerja-ps-pegawai'

const canBeEvaluated = (state: StatusPerencanaan) => {
  return state === 'SEDANG_DIPERIKSA' || state === 'SUDAH_DIREVISI'
}

type Props = {
  data: PerencanaanPS[]
  isLoading?: boolean
  className?: string
  basePath?: string
  isBulkApproval?: boolean
  openInNewTab?: boolean
}

export default function TablePerencanaanPS({
  data,
  isLoading = false,
  className,
  basePath = PENGELOLAAN_KINERJA_BASE_PATH,
  isBulkApproval = false,
  openInNewTab = false,
}: Props) {
  const isEmpty = data.length === 0

  return (
    <TablePelaksanaanKinerja className={className} fullWidth>
      <TableHeader>
        <TableHeaderItem>Nama Pengawas Sekolah</TableHeaderItem>
        <TableHeaderItem>Status</TableHeaderItem>
        <TableHeaderItem></TableHeaderItem>
      </TableHeader>
      <TableBody>
        {isLoading && <TableShimmer />}
        {!isLoading &&
          (isEmpty ? (
            // if no data found for certain state
            <TableRow>
              <TableRowItem colSpan={3}>
                <StateEmpty>
                  Pastikan terdapat Perencanaan dengan status tersebut
                </StateEmpty>
              </TableRowItem>
            </TableRow>
          ) : (
            // if data exists
            data.map((data) => (
              <TableRow
                data-testid="perencanaan-row"
                key={data.skpPsId}
                className={clsx(
                  (data.status === 'DISETUJUI_PPK' ||
                    data.status === 'PELAKSANAAN_DIMULAI') &&
                    'bg-surface-success-subdued'
                )}
              >
                <TableRowItem className="w-[332px]">
                  {data.namaPengawas}
                </TableRowItem>
                <TableRowItem className="w-[364px]">
                  <PlanningApprovalBadge state={data.status} />
                </TableRowItem>
                <TableRowItem>
                  {data.status !== 'MULAI_PERENCANAAN' &&
                    data.status !== 'SIAP_DIAJUKAN' && (
                      <Link
                        passHref
                        href={`${basePath}/penilai/perencanaan/${
                          data.skpPsId
                        }/detail${isBulkApproval ? '?from=BULK_APPROVAL' : ''}`}
                      >
                        <Button
                          as="a"
                          color={canBeEvaluated(data.status) ? 'blue' : 'white'}
                          className={clsx(
                            '!inline-flex',
                            !canBeEvaluated(data.status) && '!bg-transparent'
                          )}
                          size="sm"
                          target={openInNewTab ? '_blank' : undefined}
                        >
                          Cek
                        </Button>
                      </Link>
                    )}
                </TableRowItem>
              </TableRow>
            ))
          ))}
      </TableBody>
    </TablePelaksanaanKinerja>
  )
}
